import { Logo } from '../components/Logo'
import { Usda } from '../components/Usda';
import {
  PageContainer,
  HeroSection,
  HeroContent,
  BackLink,
  ContentSection,
  Container,
  MainContent,
  SideContent,
  ProductTitle,
  ProductSubtitle,
  SectionTitle,
  SubSectionTitle,
  Paragraph,
  InfoTable,
  TableRow,
  TableDataLabel,
  TableData,
  List,
  AcoContainer,
  DecorativeElement
} from './ProductStyles';

export const CitrusSinensis13 = () => (
  <PageContainer>
    <HeroSection>
      <BackLink to="/">ホームに戻る</BackLink>
      <HeroContent>
        <Logo />
      </HeroContent>
    </HeroSection>

    <ContentSection>
      <Container>
        <MainContent>
          <DecorativeElement className="top-right" />
          <DecorativeElement className="bottom-left" />

          <ProductTitle>イタリア産 オレンジ (ロット13)</ProductTitle>
          <ProductSubtitle>Citrus sinensis</ProductSubtitle>

          <SectionTitle>使用期限</SectionTitle>
          <Paragraph>{new Date('2027-06-30T00:00:00.000+09:00').toLocaleDateString()}</Paragraph>

          <SectionTitle>製品の特徴</SectionTitle>
          <InfoTable>
            <tbody>
              <TableRow>
                <TableDataLabel>原産国</TableDataLabel>
                <TableData>イタリア</TableData>
              </TableRow>
              <TableRow>
                <TableDataLabel>抽出部位</TableDataLabel>
                <TableData>皮</TableData>
              </TableRow>
              <TableRow>
                <TableDataLabel>抽出方法</TableDataLabel>
                <TableData>圧搾法</TableData>
              </TableRow>
              <TableRow>
                <TableDataLabel>学名</TableDataLabel>
                <TableData>Citrus sinensis</TableData>
              </TableRow>
              <TableRow>
                <TableDataLabel>科名</TableDataLabel>
                <TableData>みかん科</TableData>
              </TableRow>
              <TableRow>
                <TableDataLabel>効果</TableDataLabel>
                <TableData>リラックス、気分高揚、皮脂抑制、抗菌、空気洗浄、消化促進</TableData>
              </TableRow>
              <TableRow>
                <TableDataLabel>ロット番号</TableDataLabel>
                <TableData>13</TableData>
              </TableRow>
            </tbody>
          </InfoTable>

          <SectionTitle>分析証明書</SectionTitle>

          <SubSectionTitle>製品識別と組成</SubSectionTitle>
          <List>
            <li>製品名: Orange Essential Oil 100% Pure and Natural (ロット13)</li>
            <li>学名: Citrus sinensis</li>
            <li>バッチ番号: 11202503</li>
          </List>

          <SubSectionTitle>物理的および化学的特性</SubSectionTitle>
          <List>
            <li>外観: 淡黄色からオレンジ色の液体</li>
            <li>香り: 甘く、フレッシュ、シトラス、特徴的なアロマ</li>
            <li>屈折率: 1.472 @ 20°C</li>
            <li>比重: 0.853 @ 20°C</li>
          </List>
        </MainContent>

        <SideContent>
          <AcoContainer>
            <Usda />
          </AcoContainer>
        </SideContent>
      </Container>
    </ContentSection>
  </PageContainer>
);
